
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'category',
  setup() {
    return {}
  }
})
